import { GIFT_TERM_LABEL, type GiftTerm } from '@shared/types';
import type { JSX } from 'preact';

interface Props {
  term: GiftTerm;
  recipientName: string;
  gifterName: string;
}

/** The "card" the gifter sees while filling the form. Updates live, like Joy's. */
export function GiftCardPreview({ term, recipientName, gifterName }: Props): JSX.Element {
  return (
    <div className="card-shine relative aspect-[1.6/1] w-full overflow-hidden rounded-2xl p-5 text-white shadow-lg">
      <div className="flex items-start justify-between">
        <span className="font-heading text-2xl font-bold">Betteroo</span>
        <span className="rounded-full bg-white/20 px-3 py-1 text-xs font-semibold uppercase tracking-wide">Gift card</span>
      </div>
      <div className="absolute bottom-5 left-5 right-5">
        <p className="text-sm/5 opacity-90">{GIFT_TERM_LABEL[term]} of personalized sleep support</p>
        <p className="mt-1 truncate font-heading text-2xl font-bold">{recipientName.trim() || 'For someone you love'}</p>
        <p className="mt-1 truncate text-sm opacity-90">{gifterName.trim() ? `From ${gifterName.trim()}` : ' '}</p>
      </div>
    </div>
  );
}
